<template>
  <v-app-bar
    class="bcl-app-header px-2 px-sm-3 px-md-4"
    location="top"
    app
    fixed
  >
    <TopBarSkeleton v-if="!isSdkInitialized" />
    <div v-else class="container d-flex align-center ga-1 ga-lg-2">
      <div class="d-flex align-center">
        <AppLogo class="logo-btn mr-md-3 mr-lg-6" linked />

        <template v-if="!isMobile">
          <ul class="menu-list">
            <li
              v-for="({ routeName, text }, index) in menuItems"
              :key="index"
              class="menu-list-item"
            >
              <RouterLink
                :to="{ name: routeName }"
                class="px-1 px-md-2 px-lg-3 bcl-app-menu-link"
                :class="[route.name === routeName ? 'text-primary' : '']"
                exact
              >
                {{ text }}
              </RouterLink>
            </li>
          </ul>
        </template>
      </div>

      <v-spacer />

      <div class="options-list d-flex align-center">
        <div v-if="!isMobile" class="options-list-item">
          <NetworkSelector />
        </div>
        <div v-if="false" class="options-list-item">
          <ToggleDarkMode />
        </div>
        <div v-if="!isMobile" class="options-list-item">
          <CurrencySelector />
        </div>
        <div v-if="SETTINGS.languages.length > 1" class="options-list-item">
          <LanguageSelector />
        </div>

        <div v-if="activeAccount" class="options-list-btn">
          <ActiveAccountBtn />
        </div>
        <div v-else class="options-list-btn">
          <WalletConnectBtn size="large" outlined :hide-label="mdAndDown" />
        </div>
      </div>
    </div>
  </v-app-bar>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";
import { useRoute } from "vue-router";

import { useAccounts, useAppStore } from "@/stores";

import {
  ROUTE_ABOUT,
  ROUTE_CREATE_TOKEN,
  ROUTE_HOME,
  ROUTE_INVITE,
  SETTINGS,
} from "@/utils/constants";

import ActiveAccountBtn from "@/components/Account/ActiveAccountBtn.vue";
import WalletConnectBtn from "@/components/WalletConnect/WalletConnectBtn.vue";
import ToggleDarkMode from "@/components/Header/ToggleDarkMode.vue";
import NetworkSelector from "@/components/Header/NetworkSelector.vue";
import CurrencySelector from "@/components/Header/CurrencySelector.vue";
import LanguageSelector from "@/components/Header/LanguageSelector.vue";
import AppLogo from "@/components/Common/AppLogo.vue";
import TopBarSkeleton from "@/components/Skeletons/TopBarSkeleton.vue";

const { t } = useI18n();
const { isSdkInitialized, isMobile } = storeToRefs(useAppStore());
const { activeAccount } = storeToRefs(useAccounts());
const { mdAndDown } = useDisplay();

const menuItems = [
  {
    routeName: ROUTE_HOME,
    text: t("common.coinList"),
  },
  {
    routeName: ROUTE_CREATE_TOKEN,
    text: t("blocks.appHeader.createToken"),
  },
  {
    routeName: ROUTE_INVITE,
    text: t("blocks.appHeader.invite"),
  },
  {
    routeName: ROUTE_ABOUT,
    text: t("blocks.appHeader.about"),
  },
];

const route = useRoute();
</script>

<style scoped lang="scss">
@use "@/styles/variables" as *;

.bcl-app-header {
  backdrop-filter: blur(8px);
  box-shadow: 2px 0 20px rgba(white, 0.05) !important;
  background-color: rgba(var(--v-theme-primaryDark), 0.7);

  .menu-list {
    list-style: none;
    display: flex;
  }

  .menu-list .menu-list-item,
  .options-list .options-list-item {
    &:not(:first-child) {
      position: relative;
      padding-left: 20px;

      &::before {
        content: url('data:image/svg+xml;utf8,<svg fill="none" width="9" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 14"><path d="M0.965332 13.3V10.42L7.08533 2.93201V0.700012H8.88533V3.58001L2.76533 11.068V13.3H0.965332Z" fill="%23424245"/></svg>');
        position: absolute;
        top: 50%;
        left: 6px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
